export default {
	state: () => ({
		isActiveSideNav: false
	}),
	mutations: {
		SET_IS_ACTIVE_SIDE_NAV(state, isActiveSideNav) {
			state.isActiveSideNav = isActiveSideNav;
		}
	},
	actions: {
		SHOW_SIDE_NAV({ commit }) {
			return commit('SET_IS_ACTIVE_SIDE_NAV', true);
		},
		HIDE_SIDE_NAV({ commit }) {
			return commit('SET_IS_ACTIVE_SIDE_NAV', false);
		}
	},
	getters: {
		getIsActiveSideNav: (state) => state.isActiveSideNav
	}
};
